import {WarningBanner} from '@/components/commons/warning-banner/WarningBanner'
import {AgendaEventConsultantFields} from '@/features/agenda/components/agenda-event-form/agenda-event-consultant-fields/AgendaEventConsultantFields'
import {AgendaEventDateTimeSelector} from '@/features/agenda/components/agenda-event-form/agenda-event-date-time-selector/AgendaEventDateTimeSelector'
import {AgendaEventNotesField} from '@/features/agenda/components/agenda-event-form/agenda-event-notes-field/AgendaEventNotesField'
import {AgendaEventPatientsFields} from '@/features/agenda/components/agenda-event-form/agenda-event-patients-fields/AgendaEventPatientsFields'
import {AgendaEventRemoteFields} from '@/features/agenda/components/agenda-event-form/agenda-event-remote-fields/AgendaEventRemoveFields'
import {AgendaEventTeamMembersSelector} from '@/features/agenda/components/agenda-event-form/agenda-event-team-members-selector/AgendaEventTeamMembersSelector'
import {useAgendaFormDisabledOperation} from '@/features/agenda/hooks/useAgendaFormDisabledOperation'
import {useTranslation} from '@/translations/i18n'
import {AccessesToRecoveryField} from '../accesses-to-recover-field/AccessesToRecoverField'
import {AgendaEventAccessesCounters} from '../../agenda-event-accesses-counters/AgendaEventAccessesCounters'
import {useFormContext, useWatch} from 'react-hook-form'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {z} from 'zod'

const AgendaEventFormTeamFieldsSchema = AgendaEventFieldsSchema.pick({
    patients: true,
    consultants: true,
    category: true,
    isARecovery: true
})
type AgendaEventFormTeamFieldsSchema = z.infer<typeof AgendaEventFormTeamFieldsSchema>

export const AgendaEventFormTeamFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AgendaEventFormTeamFieldsSchema>()
    const areDisabledPatientRelatedFields = useAgendaFormDisabledOperation()
    const patients = useWatch({control, name: 'patients'})
    const consultants = useWatch({control, name: 'consultants'})
    const category = useWatch({control, name: 'category'})
    const isARecovery = useWatch({control, name: 'isARecovery'})
    return (
        <>
            <AgendaEventPatientsFields areDisabledPatientRelatedFields={areDisabledPatientRelatedFields} />
            {areDisabledPatientRelatedFields ? (
                <WarningBanner
                    title={t('agenda:unavailable_event_operation')}
                    subtitle={t('agenda:unavailable_event_operation_subtitle')}
                    maxWidth="unset"
                />
            ) : (
                <>
                    <AgendaEventConsultantFields />
                    {patients?.[0]?.project && consultants?.length == 1 && consultants?.[0]?.accessType && category && (
                        <AgendaEventAccessesCounters
                            projectId={patients[0].project.id}
                            projectStartDate={patients[0].project.startDate}
                            projectExpirationDate={patients[0].project.expirationDate}
                            accessTypeId={consultants[0].accessType.id}
                            accessType={consultants[0].accessType.accessType}
                            category={category}
                        />
                    )}
                    {patients?.[0]?.project &&
                        consultants?.length == 1 &&
                        consultants?.[0]?.accessType &&
                        category &&
                        isARecovery && (
                            <AccessesToRecoveryField
                                patientId={patients[0].id}
                                accessType={consultants[0].accessType.accessType}
                            />
                        )}
                    <AgendaEventTeamMembersSelector />
                    <AgendaEventDateTimeSelector index={0} />
                    <AgendaEventNotesField />
                    <AgendaEventRemoteFields />
                </>
            )}
        </>
    )
}
